import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { OfferStack } from '../components/OfferStack';
import { PricingSection } from '../components/PricingSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { CloseSection } from '../components/CloseSection';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-cream font-body text-brown selection:bg-sage/30" data-id="element-200">
      <UrgencyBar data-id="element-201" />
      <main data-id="element-202">
        <HeroSection data-id="element-203" />
        <StorySection data-id="element-204" />
        <TestimonialsSection data-id="element-205" />
        <OfferStack data-id="element-206" />
        <PricingSection data-id="element-207" />
        <FAQSection data-id="element-208" />
        <GuaranteeSection data-id="element-209" />
        <CloseSection data-id="element-210" />
      </main>
      <Footer data-id="element-211" />
    </div>;
}